var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useContext, useEffect, useState } from 'react';
import { useInput } from './common/use-input';
import { appEnv } from '@cta-portal/webapp-common/src/env';
import { useI18n } from '@cta-portal/webapp-common/src/hooks/translations/use-i18n';
import { Magic } from 'magic-sdk';
import { GlobalContext } from '../context/global';
import { useToggle } from './common/use-toogle';
var MAX_STEPS = 5;
export function useMigration() {
    var _this = this;
    var t = useI18n().t;
    var setLoading = useContext(GlobalContext).setLoading;
    var email = useInput('');
    var username = useInput('');
    var account = useInput('');
    var migrationAuthEmail = useInput('');
    var emailAuth = 'mickael.rassicot@gmail.com';
    var checkboxes1 = useToggle();
    var checkboxes2 = useToggle();
    var checkboxes3 = useToggle();
    var checkboxes4 = useToggle();
    var checkboxes5 = useToggle();
    var mainCheckboxExportAccountsKeys = useToggle();
    var checkboxesValidates = [checkboxes1, checkboxes2, checkboxes3, checkboxes4, checkboxes5];
    var _a = useState(null), accounts = _a[0], setAccounts = _a[1];
    var _b = useState({}), exportAccountCheckboxesStates = _b[0], setExportAccountCheckboxesStates = _b[1];
    var _c = useState(null), recapAssetsMigration = _c[0], setRecapAssetsMigration = _c[1];
    var _d = useState(false), isMagicLoggedIn = _d[0], setIsMagicLoggedIn = _d[1];
    var magic = new Magic(appEnv.blockchain.magicLinkApiKey, {
        network: appEnv.isLive
            ? 'mainnet'
            : {
                rpcUrl: 'https://rpc2.sepolia.org',
                chainId: 11155111,
            },
    });
    function checkValidity(step) {
        if (step === 1) {
            if (!account.bind.value || !username.bind.value || !email.bind.value) {
                return t('account-migration.error.missing-fields');
            }
            else {
                return true;
            }
        }
        else if (step === 2) {
            if (!checkboxes1.checked ||
                !checkboxes2.checked ||
                !checkboxes3.checked ||
                !checkboxes4.checked ||
                !checkboxes5.checked) {
                return t('account-migration.error.missing-checkboxes');
            }
            else {
                return true;
            }
        }
        else if (step === 3) {
            if (!isMagicLoggedIn) {
                return t('account-migration.error.missing-magic-link-auth');
            }
            else {
                return true;
            }
        }
        else if (step === 5) {
            if (Object.values(exportAccountCheckboxesStates).some(function (checkboxes) { return checkboxes.ctaWallet === false || checkboxes.gameWallet === false; }) ||
                !mainCheckboxExportAccountsKeys.checked) {
                return t('account-migration.error.missing-export-checkboxes');
            }
            else {
                return true;
            }
        }
        else {
            return true;
        }
    }
    function migrationAuthSubmit() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 3000); })];
                    case 1:
                        _a.sent();
                        setLoading(false);
                        return [2 /*return*/, true];
                }
            });
        });
    }
    function submit() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 3000); })];
                    case 1:
                        _a.sent();
                        if (email.bind.value.length === 0) {
                            email.setError(t('account-migration.error.email'));
                        }
                        console.log(email.bind.value, username.bind.value, account.bind.value);
                        setLoading(false);
                        return [2 /*return*/, true];
                }
            });
        });
    }
    useEffect(function () {
        var fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
            function generateUserAccounts(max) {
                return __awaiter(this, void 0, Promise, function () {
                    return __generator(this, function (_a) {
                        // await new Promise((resolve) => setTimeout(resolve, 3000))
                        return [2 /*return*/, Array.from({ length: max }, function (_, index) {
                                var userId = index + 1;
                                return {
                                    id: userId,
                                    username: "Test ".concat(userId),
                                    email: "test".concat(userId, "@test.fr"),
                                    level: Math.floor(Math.random() * 100) + 1,
                                    flexCardsCount: Math.floor(Math.random() * 1000) + 1,
                                    flexChestsCount: Math.floor(Math.random() * 10) + 1,
                                    eternalCardsCount: Math.floor(Math.random() * 1000) + 1,
                                    eternalChestsCount: Math.floor(Math.random() * 10) + 1,
                                    freeMintCount: Math.floor(Math.random() * 100) + 1,
                                    triselCount: Math.floor(Math.random() * 1000000) + 1,
                                    eternalStoneCount: Math.floor(Math.random() * 100) + 1,
                                };
                            })];
                    });
                });
            }
            var randomMax, userAccounts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        randomMax = Math.floor(Math.random() * 10) + 1;
                        return [4 /*yield*/, generateUserAccounts(randomMax)];
                    case 1:
                        userAccounts = _a.sent();
                        setExportAccountCheckboxesStates(userAccounts.reduce(function (acc, account) {
                            acc[account.id] = {
                                ctaWallet: Math.random() > 0.5 ? false : undefined,
                                gameWallet: Math.random() > 0.5 ? false : undefined,
                            };
                            return acc;
                        }, {}));
                        setRecapAssetsMigration(userAccounts.reduce(function (acc, account) {
                            acc.flexCardsCount = (acc.flexCardsCount || 0) + (account.flexCardsCount || 0);
                            acc.flexChestsCount = (acc.flexChestsCount || 0) + (account.flexChestsCount || 0);
                            acc.eternalCardsCount = (acc.eternalCardsCount || 0) + (account.eternalCardsCount || 0);
                            acc.eternalChestsCount = (acc.eternalChestsCount || 0) + (account.eternalChestsCount || 0);
                            acc.freeMintCount = (acc.freeMintCount || 0) + account.freeMintCount;
                            acc.triselCount = (acc.triselCount || 0) + account.triselCount;
                            acc.eternalStoneCount = (acc.eternalStoneCount || 0) + account.eternalStoneCount;
                            return acc;
                        }, {}));
                        setLoading(false);
                        setAccounts(userAccounts);
                        return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, []);
    var toggleExportAccountCheckboxesStates = function (accountId, type) {
        setExportAccountCheckboxesStates(function (prev) {
            var _a, _b;
            return (__assign(__assign({}, prev), (_a = {}, _a[accountId] = __assign(__assign({}, prev[accountId]), (_b = {}, _b[type] = !prev[accountId][type], _b)), _a)));
        });
    };
    function loginWithMagicLink() {
        return __awaiter(this, void 0, void 0, function () {
            var handle, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, magic.auth.loginWithEmailOTP({
                                email: emailAuth,
                                showUI: true,
                                deviceCheckUI: true,
                            })];
                    case 2:
                        handle = _a.sent();
                        if (handle) {
                            setIsMagicLoggedIn(true);
                            setLoading(false);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        if (err_1 instanceof Error) {
                            throw new Error('[loginWithMagicLink] login failed.');
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    return {
        email: email,
        username: username,
        account: account,
        accounts: accounts,
        steps: MAX_STEPS,
        checkboxesValidates: checkboxesValidates,
        checkValidity: checkValidity,
        exportAccountCheckboxesStates: exportAccountCheckboxesStates,
        toggleExportAccountCheckboxesStates: toggleExportAccountCheckboxesStates,
        mainCheckboxExportAccountsKeys: mainCheckboxExportAccountsKeys,
        recapAssetsMigration: recapAssetsMigration,
        submit: submit,
        migrationAuthEmail: migrationAuthEmail,
        migrationAuthSubmit: migrationAuthSubmit,
        loginWithMagicLink: loginWithMagicLink,
        isMagicLoggedIn: isMagicLoggedIn,
        emailAuth: emailAuth,
    };
}
